import { connect } from 'react-redux'
import { getUserDto, getUserCompanies, hasRoleInCompany } from '../../common/auth/authSelectors'
import { IGlobalState } from '../../Root/store/appReducer'
import {
  getCurrentGoalActivityList,
  getCurrentGoalActivityListClear,
  getCurrentGoalExport,
  joinGoal,
} from '../../views/Activity/store/ActivityActions'
import {
  getActivityFilter,
  getActivityProgress,
  getActivityProgressLoading,
  getUserIsInActivityList,
  getActivityView,
  getDivisionActivityProgress,
  getCountryActivityProgress,
  getActivityPeriodPercentage,
  getGroupView,
  getGroupSum,
} from '../../views/Activity/store/ActivitySelectors'
import { YumGoalRanking, IDispatchProps, IStateProps } from './YumGoalRanking'
import { companyDivisionsSelector, companyCountriesSelector } from '../../views/Settings/store/SettingsSelectors'
import { CompanyId, GoalWithProgress, Role } from '../../services/api.types'
import { getLoadingJoinGoal } from '../../common/loading/loadingSelectors'

export interface IOwnProps {
  goalDto: GoalWithProgress
  token?: string
  isNewLayout?: boolean
}

const mapStateToProps = (state: IGlobalState, ownProps: IOwnProps): IStateProps => {
  const { goalDto, token, isNewLayout } = ownProps
  const goalId = goalDto.id
  return {
    hasRoleInCompany: (companyId: CompanyId, role: Role) => hasRoleInCompany(state, companyId, role),
    goalDto,
    userDto: getUserDto(state),
    userCompanies: getUserCompanies(state),
    activityView: getActivityView(state, goalId),
    activityFilter: getActivityFilter(state, goalId),
    groupView: getGroupView(state, goalId),
    groupSum: getGroupSum(state, goalId),
    activityProgress: getActivityProgress(state, goalId),
    divisionActivityProgress: getDivisionActivityProgress(state, goalId),
    countryActivityProgress: getCountryActivityProgress(state, goalId),
    activityPeriodPercentage: getActivityPeriodPercentage(state, goalId),
    activityProgressLoading: getActivityProgressLoading(state, goalId),
    userIsInActivityList: getUserIsInActivityList(state, goalId),
    divisions: companyDivisionsSelector(state),
    countries: companyCountriesSelector(state),
    joinInProgress: getLoadingJoinGoal(state),
    token,
    isNewLayout,
  }
}

const mapDispatchToProps: IDispatchProps = {
  getCurrentGoalActivityList,
  getCurrentGoalActivityListClear,
  getCurrentGoalExport,
  joinGoal,
}

export default connect(mapStateToProps, mapDispatchToProps)(YumGoalRanking)
